import { render } from "./LoaderInfinityMore.vue?vue&type=template&id=63a56864&scoped=true"
import script from "./LoaderInfinityMore.vue?vue&type=script&lang=js"
export * from "./LoaderInfinityMore.vue?vue&type=script&lang=js"

import "./LoaderInfinityMore.vue?vue&type=style&index=0&id=63a56864&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63a56864"]])

export default __exports__